import {Injectable } from '@angular/core';
import {Location} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  constructor(
    private _location: Location
  ) { }

  goBack() {
		this._location.back();
	}



}

